import React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PageContainer, PageContent } from '../component/Containers/Containers';
import { ContentText } from '../component/PageComponents/InfoComponents/InfoComponents';
import { setIsLoadingTo } from '../store/features/adminSlice';

/**
 * @component
 * This Privacy componente reflects the privacy policies associated with the App.
 * @returns {void}
 */
const Privacy = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setIsLoadingTo(false));
  }, [dispatch]);

  return (
    <PageContainer>
      <PageContent>
        <ContentText style={{ maxWidth: '96%', marginRight: '30px' }}>
          Los Centros Tecnológicos Comunitarios no recopilan ni hacen uso de
          datos provenientes de los dispositivos de los usuarios finales, fuera
          de los datos generales sobre el dispositivo en cuestión o cookies de
          navegación que se recogen por defecto al navegar por internet. Para
          mayor detalle sobre el uso de datos privados en móvil y en la web,
          favor referirse a los Términos de Uso, apartado 3.
        </ContentText>
      </PageContent>
    </PageContainer>
  );
};

export default Privacy;
